import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["source", "button"]

  initialize(){
    this.initialContents = this.buttonTarget.innerHTML
  }

  copy(){
    navigator.clipboard.writeText(this.sourceTarget.value)
    this.buttonTarget.innerHTML = "Copied!"
    setTimeout(() => {
      this.buttonTarget.innerHTML = this.initialContents
    }, 2500)
  }
}
